import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Biking World',
        projectDesc: 'This is full Stack Project where User can easily buy bikes , payments, reviews submit .On the other hand admin can add bike with The Contents also remove products from this website.',
        tags: ['React', 'Tailwind CSS', 'Material Ui', 'Firebase Hosting', 'Nodejs', 'Express Js', 'MongoDB', 'Heroku'],
        code: 'https://github.com/programming-hero-web-course1/tourism-or-delivery-website-client-side-AbdullahShion',
        demo: 'https://bike-zone-9e78d.web.app/home',
        image: one
    },
    {
        id: 2,
        projectName: 'Traveling Zone',
        projectDesc: 'This is Traveling website where user can booking place also client has an option to add a location.',
        tags: ['React', 'Tailwind CSS', 'Material Ui', 'Firebase Hosting', 'Nodejs', 'Express Js', 'MongoDB', 'Heroku'],
        code: 'https://github.com/programming-hero-web-course1/tourism-or-delivery-website-client-side-AbdullahShion',
        demo: 'https://travel-agency-bb102.web.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Medico Zone',
        projectDesc: ' Here You Will Find not only doctors details also you can research about them You can Also contact to the health care center.Authentication systems like, email-password and Google Sign in.',
        tags: ['React', 'Tailwind CSS', 'Material Ui', 'Firebase Hosting', 'Nodejs', 'Express Js', 'MongoDB', 'Heroku'],
        code: 'https://github.com/Programming-Hero-Web-Course3/healthcare-related-website-AbdullahShion',
        demo: 'https://health-care-26898.web.app/',
        image: three
    },
    {
        id: 4,
        projectName: 'Selling Course',
        projectDesc: 'This project involves the development of an React application for viewing and managing Course data.',
        tags: ['React', 'Tailwind CSS', 'Material Ui', 'Firebase Hosting', 'Nodejs', 'Express Js', 'MongoDB', 'Heroku'],
        code: 'https://github.com/ProgrammingHeroWC4/review-website-AbdullahShion',
        demo: 'https://abdullaheducation.netlify.app/',
        image: four
    },
    {
        id: 5,
        projectName: 'Singer Community Bangladesh',
        projectDesc: 'A Simple React application',
        tags: ['React', 'Tailwind CSS', 'Firebase Hosting', 'Nodejs'],
        code: 'https://github.com/ProgrammingHeroWC4/the-superhero-direction-AbdullahShion',
        demo: 'https://abdullahshion8.netlify.app/',
        image: five
    },
    {
        id: 6,
        projectName: 'Weather Apps',
        projectDesc: 'You can find all country weather here',
        tags: ['HTML','CSS','Javascript'],
        code: 'https://github.com/AbdullahShion/Weather-Showcasing',
        demo: 'https://abdullahshion.github.io/Weather-Showcasing/',
        image: six
    },
    {
        id: 7,
        projectName: 'Panda Commerce',
        projectDesc: 'A simple HTML , CSS, Javascript Pojects',
        tags: ['HTML','CSS','Javascript'],
        code: 'https://abdullahshion.github.io/panda-commerce-bootstrap/',
        demo: 'https://github.com/AbdullahShion/panda-commerce-bootstrap',
        image: seven
    },
    {
        id: 8,
        projectName: 'Banking System',
        projectDesc: 'You can login email abdullahshion55@gmail.com and password abdullah',
        tags: ['HTML','CSS','Javascript'],
        code: 'https://github.com/AbdullahShion/baap-er-bank',
        demo: 'https://abdullahshion.github.io/baap-er-bank/',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/